import React from "react";
import { css } from "@emotion/react";
import consulting from "@src/assets/expert/consulting.png";
import writingFace from "@src/assets/expert/writingFace.png";
import {
    noticeContainerStyle,
    TitleStyle,
    ContentContainerStyle,
    BlueBoxStyle,
    BlueTitleStyle,
    BlackTitleStyle,
    BlackSubTitleStyle,
    BlackStepStyle,
    BlackContentStyle,
    GreyContentStyle,
    dividerStyle,
    FlexColumnStyle,
    DarkGreyContentStyle,
} from "./TakerAgentNotice";

const UserConsultNotice = () => {
    return (
        <div css={noticeContainerStyle}>
            <div css={TitleStyle}>
                매물컨설팅 <br />
                <span style={{ fontWeight: "normal", fontSize: "18px" }}>서비스 이렇게 진행돼요!</span>
            </div>
            <div css={ContentContainerStyle}>
                {/* Step1 */}
                <div className="stepBox">
                    <img src={consulting} alt="consulting" className="stepIcon" width={50} height={50} />
                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>step.01</span> 매물컨설팅
                    </p>
                    <div css={BlueBoxStyle}>
                        <p css={BlackSubTitleStyle}>경매 전문가에게 권리분석 등 매물에 대한 컨설팅을 받아요. </p>
                        <p css={BlackContentStyle}>
                            ✔️ 컨설팅 비용 : 33만원 <br />
                            ✔️ 매칭 1회 실패시, 의뢰인은 컨설팅 비용을 <br />
                            최대 80만원까지 올려 다시 요청할 수 있어요.
                        </p>
                        <div css={dividerStyle} style={{ margin: "8px 0" }} />

                        <div css={FlexColumnStyle} style={{ marginTop: "24px" }}>
                            <div>
                                <p css={BlueTitleStyle}>❶ 의뢰 요청</p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    매물의 사건번호, 요청사항을 입력하고
                                    <br /> 전국에 있는 경매대행 전문가에게 즉시 <br />
                                    컨설팅 의뢰를 보내요.
                                </p>
                            </div>
                            <div>
                                <p css={BlueTitleStyle}>❷ 원하는 전문가 선택</p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    전문가들은 해당 의뢰에 실시간으로 지원하고, <br />
                                    의뢰인은 지원한 전문가들의 프로필을 확인하거나 <br />
                                    채팅을 하며 자신이 원하는 전문가를 직접 선택해요.
                                </p>
                            </div>
                            <div>
                                <p css={BlueTitleStyle}>❸ 매칭 완료</p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    지원한 전문가 중 한 명을 선택하고 ‘매칭확정하기’를 눌러 담당 전문가로 지정하면, 매칭이
                                    완료돼요.
                                </p>
                            </div>
                            <div>
                                <p css={BlueTitleStyle}>❹ 컨설팅 </p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    매칭이 확정된 전문가에게 내가 의뢰한 매물의 권리 분석, 입지 분석 등 매물에 대한 컨설팅을
                                    받아요.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Step2 */}
                <div className="stepBox">
                    <img src={writingFace} alt="step4" className="stepIcon" width={50} height={50} />

                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>step.02</span> 후기 작성
                    </p>
                    <p css={DarkGreyContentStyle} style={{ marginTop: "14px" }}>
                        매칭된 전문가에 대한 후기를 작성해요. <br />
                        제공 받은 컨설팅 서비스가 어땠는지
                        <br /> 좋은 점, 아쉬운 점을 작성해주세요.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UserConsultNotice;

const GreyBoxStyle = css`
    width: 100%;
    padding: 14px;
    background-color: #f3f4f8;
    border-radius: 14px;
`;

const FlexRowStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;
